var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpenGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7666 8.50004C1.7666 8.50004 3.7666 3.83337 8.43327 3.83337C13.0999 3.83337 15.0999 8.50004 15.0999 8.50004C15.0999 8.50004 13.0999 13.1667 8.43327 13.1667C3.7666 13.1667 1.7666 8.50004 1.7666 8.50004Z",
    stroke: "#8B8B8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43327 10.5C9.53784 10.5 10.4333 9.60461 10.4333 8.50004C10.4333 7.39547 9.53784 6.50004 8.43327 6.50004C7.3287 6.50004 6.43327 7.39547 6.43327 8.50004C6.43327 9.60461 7.3287 10.5 8.43327 10.5Z",
    stroke: "#8B8B8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenGray);
export default __webpack_public_path__ + "static/media/eye-open-gray.7b542cbea5d280dbbe0fea1a0b05435f.svg";
export { ForwardRef as ReactComponent };